<template>
  <b-overlay :show="usersLoading" class="rounded" variant="transparent">
    <template #overlay>
      <b-img
        width="100"
        :src="require('@/assets/img/brand/loader.gif')"
        alt=""
      />
    </template>
    <div class="card shadow p-3">
      <div class="card-header border-0">
        <base-title
          :title="$route.params.id ? $t('users-administrator') : title"
          popover="Listado de usuarios registrados en M2M"
        >
          <template slot="button">
            <div class="col text-right" v-if="modal">
              <b-button
                size="sm"
                variant="primary"
                @click="
                  modal ? update() : $router.push({ name: 'create_users' })
                "
                >{{ $t("add") }}</b-button
              >
            </div>
          </template>
        </base-title>
      </div>

      <b-row>
        <b-col md="2">
          <b-form-select
            v-model="filter.per_page"
            :options="[5, 10, 20, 100]"
            size="sm"
            class="mt-2"
            @input="debouncedGetAnswer()"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
          <b-form-group>
            <b-form-input
              class="form-control-sm"
              id="filter-input"
              v-model="filter.search"
              type="search"
              :placeholder="$t('search')"
              @input="debouncedGetAnswer()"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="tableData.data"
            :fields="columns"
            :per-page="filter.per_page"
            :current-page="filter.current_page"
            :busy="
              !Array.isArray(tableData.data) || tableData.data.length === 0
                ? true
                : false
            "
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <span class="h2 text-danger">{{ $t("fail") }}</span>
              </div>
            </template>
            <template v-slot:cell(status)="data">
              <b-badge
                class="text-white"
                size="lg"
                :class="data.item.isDisabled === 0 ? 'bg-success' : 'bg-danger'"
                >{{
                  data.item.isDisabled === 0 ? $t("enable") : $t("disable")
                }}</b-badge
              >
            </template>
            <template v-slot:cell(balance)="data">
              {{ data.item.balance }} MP
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                variant="success"
                size="sm"
                @click="$refs.create.showModal(data.item.id)"
                ><i class="ri-add-line"></i> {{ $t("add_whp") }}
              </b-button>
              <!-- <b-button
              v-if="data.item.isDisabled === 0"
              v-b-tooltip.hover
              :title="$t('disable')"
              variant="danger"
              size="sm"
              @click="deleteUser(data.item.id, 2)"
              ><i class="far fa-minus-square"></i
            ></b-button>
            <b-button
              v-else
              v-b-tooltip.hover
              :title="$t('enable')"
              variant="success"
              size="sm"
              @click="deleteUser(data.item.id, 0)"
              ><i class="far fa-check-circle"></i
            ></b-button> -->
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="tableData.current_page"
            :total-rows="tableData.total"
            :per-page="tableData.per_page"
            :page-count="tableData.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal id="modal-user" size="lg" :title="$t('users')" hide-footer>
        <createOrUpdate :data="dataUser" @close="hideUser" :modal="modal" />
      </b-modal>
      <b-modal
        id="modal-user-validate"
        :title="$t('headerEmailValid')"
        v-if="modal"
        hide-footer
      >
        <email-validate @modal="showModalUser" />
      </b-modal>
      <modal-create ref="create" @refresh="syncData()" />
    </div>
  </b-overlay>
</template>
<script>
import createOrUpdate from "./form/createOrUpdate.vue";
import emailValidate from "./form/emailValidate.vue";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ModalCreate from "./whp_users/modalApp.vue";

import _ from "lodash";
export default {
  name: "user-table",
  props: {
    type: {
      type: String,
    },
    title: String,
    modal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    createOrUpdate,
    emailValidate,
    ModalCreate,
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.syncData, 200);
    await this.syncData();
  },
  data() {
    return {
      filter: {
        per_page: 5,
        page: 1,
        search: null,
      },
      dataUser: [],
      userId: null,
    };
  },
  methods: {
    ...mapActions({
      getUsers: "fetchUsers",
      asignUserCompany: "asignUserCompany",
    }),
    async syncData() {
      const { per_page, page, search } = this.filter;
      const payload = {
        per_page,
        page,
        search,
        paginated: true,
        company_id: this.modal ? this.$route.params.id : null,
      };
      await this.getUsers(payload);
    },
    async changePage(value) {
      this.filter.page = value;
      await this.debouncedGetAnswer();
    },
    async deleteUser(id, status) {
      await Swal.fire({
        title: this.$t("are_you_sure?"),
        text: this.$t("question_delete_users"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await this.delUser({ id: id, disabled: status });
            this.$toast.success(res.message, {
              position: "top-right",
            });
            // await this.changePerPage();
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    async update(id) {
      if (!id) {
        this.dataUser = null;
        if (this.modal) this.$bvModal.show("modal-user-validate");
        else this.$bvModal.show("modal-user");
      } else {
        const res = await this.showProduct(id);
        this.dataUser = res.data;
        if (this.modal) this.$bvModal.show("modal-user-validate");
        else this.$bvModal.show("modal-product");
      }
    },
    showModalUser(type) {
      if (type) this.userId = type.data.id;
      this.$bvModal.hide("modal-user-validate");
      Swal.fire({
        title: type ? type.message : this.$t("unregisteredUser"),
        text: type
          ? `¿${this.$t("wantassignUser")} ${type.data.name} ${
              type.data.lastname
            } ${this.$t("toThisCompany")}?`
          : `¿${this.$t("youWantregisterUser")}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          type ? await this.addUserCompany() : this.$bvModal.show("modal-user");
        }
      });
    },
    async addUserCompany() {
      try {
        const res = await this.asignUserCompany({
          user_id: this.userId,
          company_id: this.$route.params.id,
        });
        this.$toast.success(res.message, {
          position: "top-right",
        });
        // await this.changePerPage();
      } catch (error) {}
    },
    async hideUser(id) {
      this.$bvModal.hide("modal-user");
      if (id) {
        this.userId = id;
        await this.addUserCompany();
      }
    },
  },
  computed: {
    ...mapGetters({
      tableData: "getUsers",
      usersLoading: "usersLoading",
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t("lastname"), key: "lastname", class: "text-center" },
        { label: this.$t("nickname"), key: "nickname", class: "text-center" },
        { label: this.$t("email"), key: "email", class: "text-center" },
        { label: this.$t("balance"), key: "balance", class: "text-center" },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
  },
};
</script>